export function queryPage (query) {
  const p = parseInt(query.page)
  return p || 1
}
